import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import SwitchButton from "components/SwitchButton";

type TopPickSwitchProps = {
  checked?: boolean;
  onSwitch?: (_checked: boolean) => void;
};

const TopPickSwitch = ({ checked, onSwitch }: TopPickSwitchProps) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip>
          <div className="text-left">
            Top Insights selected by analysts. Every month, analysts get to
            shortlist up to 2 Insights as Top Picks (⭐️). These represent their
            highest conviction ideas.
          </div>
        </Tooltip>
      }
    >
      <div>
        <SwitchButton
          checked={checked}
          onClick={() => onSwitch && onSwitch(!checked)}
        >
          Top Picks Only
        </SwitchButton>
      </div>
    </OverlayTrigger>
  );
};

export default TopPickSwitch;
